import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import moment from 'moment';
import CompanyAPI from 'api/company';
import confirmModal from 'components/Modal/ConfirmModal';
import SuiButton from 'components/SuiButton';

const removeDump = (id, refetch) => {
  const CONFIG = {
    title: 'Czy na pewno chcesz usunąć ten zrzut ?',
    confirmButtonText: 'Tak',
    cancelButtonText: 'Nie',
    action: async () => {
      await CompanyAPI.deleteDump(id);
      refetch();
    },
    successText: 'Zrzut został usunięty.',
    errorText: 'Uuups, coś poszło nie tak.',
  };
  confirmModal(CONFIG);
};

const getTableData = (data, refetch) => {
  const { results } = data;
  const tableData = {
    columns: [
      {
        Header: 'Data zrzutu',
        accessor: 'date',
        sortable: true,
        key: 'dumps.date',
      },
      {
        Header: 'Pojazd zrzucający',
        accessor: 'truck',
        sortable: true,
        key: 'dumps.truck.number',
      },
      {
        Header: 'Rodzaj zrzuconych nieczystości',
        accessor: 'impuritiesType',
        sortable: true,
        key: 'dumps.impuritiesType',
      },
      {
        Header: 'Objętość (m3)',
        accessor: 'capacity',
        sortable: true,
        key: 'dumps.capacity',
      },
      {
        Header: 'Usuń',
        accessor: 'delete',
        width: '8%',
        key: 'delete',
      },
    ],
    rows: results.map((row) => ({
      ...row,
      date: moment(row.date).format('YYYY-MM-DD'),
      impuritiesType: row.impuritiesType === 'household' ? 'Bytowe' : 'Przemysłowe',
      capacity: `${row.capacity}m3`,
      delete: (
        <Tooltip title={row.status === 'sent' || row.status === 'approved' ? 'Ten zrzut jest powiązany z wysłanym lub zatwierdzonym raportem więc nie może zostać usunięty.' : 'Usuń'} placement="top">
          <span>
            <SuiButton
              disabled={row.status === 'sent' || row.status === 'approved'}
              onClick={() => removeDump(row.id, refetch)}
              variant="outlined"
              color="error"
              circular
              iconOnly
            >
              <DeleteIcon fontSize="large" />
            </SuiButton>
          </span>
        </Tooltip>
      ),
    })),
  };
  return tableData;
};

export { getTableData };
